import * as React from 'react'

import classNames from 'classnames/bind'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  label: string | React.ReactElement<any>
  information?: string
  underline?: boolean
  readonly?: boolean
  field: Field
}

const LabeledCheckbox = ({ label, field, underline, readonly = false, information }: Props) => {
  const onChange = () => {
    field.mapAndSet(!field.value)
  }

  return (
    <label
      className={cx('label', {
        readonly,
      })}
    >
      <input
        type="checkbox"
        disabled={readonly}
        checked={field.value}
        onChange={onChange}
        className={styles.input}
      />
      <span
        className={cx('text', {
          underline,
          readonly,
        })}
      >
        {label}
      </span>
      {information && (
        <div className={styles.information}>
          <InformationTooltip information={information} />
        </div>
      )}
    </label>
  )
}

export default observer(LabeledCheckbox)
